import * as React from 'react';

import cx from 'classnames';
import { CdnImagePath } from 'lib/cdn-image-path';
import { useDetectPrint } from 'lib/use-detect-print';

import { CtaBoxText } from 'components/cta-box';
import { Header3, P1 } from 'components/typography';

type Props = {
  align?: 'center';
  title: string;
  content: string;
  icon?: 'smiley' | 'cookie';
  color?: 'black' | 'orange' | 'primary';
  showSlider?: boolean;
};

const SliderBox: React.FC<Props> = ({
  align,
  title,
  content,
  icon = 'smiley',
  color = 'black',
  showSlider = true,
}) => {
  const isPrinting = useDetectPrint();
  const classnames = {
    block: cx({
      'slider-box': true,
      'slider-box--primary': color === 'primary',
      'slider-box--orange': color === 'orange',
      'slider-box--center': align === 'center',
    }),
  };
  return (
    <section className={classnames.block}>
      <h3>
        <Header3 as="span">{title}</Header3>
      </h3>
      <div className="slider-box__text">
        <CtaBoxText>
          <P1 html={content} as="p" />
        </CtaBoxText>
      </div>
      {!isPrinting && showSlider ? (
        <div className="slider-box__progress">
          <div className="slider-box__progress-bar">
            <img
              className="slider-box__progress-smiley"
              src={
                icon === 'smiley'
                  ? `${CdnImagePath}/landing/assets/icons/smiley-hearts.png`
                  : `${CdnImagePath}/landing/assets/icons/cookie.png`
              }
              alt=""
            />
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default SliderBox;
